// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchBox_wrapper__17GcP","search":"SearchBox_search__XbzbH","searchButton":"SearchBox_searchButton__1u8iD"};